
import Vue from "vue"

export default Vue.extend({
  computed: {
    stats () {
      return [
        {
          title: this.$t("wyfStats.requests"),
          value: "336 000",
        },
        {
          title: this.$t("wyfStats.participants"),
          value: "20 000",
        },
        {
          title: this.$t("wyfStats.volunteers"),
          value: "5 000",
        },
        {
          title: this.$t("wyfStats.volunteerHours"),
          value: "122 896",
        },
        {
          title: this.$t("wyfStats.worldCountries"),
          value: "190",
        },
        {
          title: this.$t("wyfStats.events"),
          value: "1 200",
        },
        {
          title: this.$t("wyfStats.experts"),
          value: "1 500",
        },
        {
          title: this.$t("wyfStats.partners"),
          value: "300",
        },
      ]
    },
  },
})
